/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Card, CardBody, CardTitle, Col, Media, Button, Form, FormGroup, Label, Input, Alert, FormText} from 'reactstrap';
import { Spring } from 'react-spring'
import { TimingAnimation, Easing } from 'react-spring/dist/addons'
import { Link, Redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../translations/global.json"
import LanguageToggle from "./selectors/language-selector";
/** End of Multiple Language imports **/

import LanguageManager from '../custom-classes/language-manager';

import FormGroupUsername from './forms/form-group-username';
import FormGroupEmail from './forms/form-group-email';
import FormGroupNewPassword from './forms/form-group-new-password';
import FormGroupAddress from './forms/form-group-address';
import FormGroupName from './forms/form-group-name';
import FormGroupPhone from './forms/form-group-phone';
import ModalChildrenPolicy from './modals/modal-child-policy';
import ModalTerms from './modals/modal-terms';
import ModalGeneric from './modals/modal-generic';
import ApiCalls from '../custom-classes/api-calls';
import SessionManager from '../custom-classes/session-manager';

/**
 * The form to register new users
 */
class Register extends React.Component{

    constructor(props){ // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
            firstName: '',
            lastName: '',
            password: '',
            passwordRetype: '',
            username: '',
            email: '',
            phone: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            validPassword: false,
            validEmail: false,
            usernameAvailable: true,
            validUsername: false,
            validFirstName: false,
            validLastName: false,
            validPhone: false,
            validAddress: false,
            validCity: false,
            validState: false,
            validCountry: false,
            validZipCode: false,
            proceedPart2: false,
            proceedPart3: false,
            proceedToInsert: false,
            showFormPart1: true,
            showFormPart2: false,
            showFormPart3: false,
            showModalTerms: false,
            showModalChildrensPolicy: false,
            checkPolicyAccepted: false,
            checkChildPolicyAccepted: false,
            propsModal: null,
            showErrorModal: false,
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });
        this.props.addTranslation(global);

        // If you are going to bind something, like onClick, or onChange, you must do the following lines
        this.handleFormPart2Visibility = this.handleFormPart2Visibility.bind(this);
        this.handleFormPart3Visibility = this.handleFormPart3Visibility.bind(this);
        this.toggleModalTerms = this.toggleModalTerms.bind(this);
        this.toggleModalChildrenPolicy = this.toggleModalChildrenPolicy.bind(this);
        this.openModalTerms = this.openModalTerms.bind(this);
        this.toggleCheckChildrenPolicy = this.toggleCheckChildrenPolicy.bind(this);
        this.toggleCheckTerms = this.toggleCheckTerms.bind(this);
        this.submitRegister = this.submitRegister.bind(this);
        this.backToPart1Register = this.backToPart1Register.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);

    }

    /**
     * Renders the generic modal
     * @returns {XML}
     */
    renderGenericModal(){
        return (
            <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/>
        );
    }

    /**
     * Toggles alert modal (alert from registration)
     */
    toggleAlertModal(){
        this.setState({showErrorModal: false});
    }

    /**
     * Submit register
     */
    submitRegister(){
        // Submits the registration

        let apiCall = ApiCalls.registerUser(this.state.username, this.state.password, this.state.passwordRetype,
            this.state.email, this.state.firstName, this.state.lastName, this.state.phone, this.state.addressLine1, this.state.addressLine2,
        this.state.city, this.state.state, this.state.country, this.state.zipCode, this.state.country);
        apiCall.then((returned)=>{
            if(!returned.TransactionValid) {
                let propsModal = {
                    bodyText: returned.Messages[0],
                    visible: true
                };
                this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
            }
            else
            {
                SessionManager.setSession(returned.Token);
                this.setState({isLoggedIn: true})
            }
        });
    }

    /**
     * Open the modal terms
     */
    openModalTerms(){
        this.setState({showModalTerms: true});
    }

    /**
     * Toggle the children policy checked / unchecked
     * @param event
     */
    toggleCheckChildrenPolicy(event){
        this.setState({checkChildPolicyAccepted: event.target.checked}, ()=>{
            this.setSubmitButtonState();
        });
    }

    /** Toggles terms policy checked / unchecked
     *
     * @param event
     */
    toggleCheckTerms(event){
        this.setState({checkPolicyAccepted: event.target.checked}, ()=>{
            this.setSubmitButtonState();
        });
    }

    /**
     * Toggle the terms modal
     */
    toggleModalTerms() {
        this.setState({showModalTerms: !this.state.showModalTerms});
    }

    /**
     * Toggle de modal children policy
     */
    toggleModalChildrenPolicy() {
        this.setState({showModalChildrensPolicy: !this.state.showModalChildrensPolicy});
    }

    /**
     * Handles if part 2 must be showed or not
     */
    handleFormPart2Visibility(){
       this.setState({showFormPart1: false, showFormPart2: true, showFormPart3: false});
    };

    /**
     * Returns to part1
     */
    backToPart1Register(){
        this.setState({showFormPart1: true, showFormPart2: false, showFormPart3: false});
    }

    /**
     * Handles if part 3 must be showed or not
     */
    handleFormPart3Visibility(){
        this.setState({showFormPart1: false, showFormPart2: false, showFormPart3: true});
    };

    /**
     * Set the button state for part 2 (button of part 1)
     */
    setNextButtonStatePart1(){
        this.setState({proceedPart2:(this.state.validUsername
        && this.state.validEmail
        && this.state.validPassword
        && this.state.usernameAvailable
        && this.state.emailAvailable)});
    }

    /**
     * Set the button state for part 3 (button of part 2)
     */
    setNextButtonStatePart2(){
        this.setState({proceedPart3:(this.state.validFirstName && this.state.validLastName && this.state.validPhone)});
    }

    /**
     * Sets if submit button is ready or not
     */
    setSubmitButtonState(){
        this.setState({proceedSubmit:(
            this.state.validAddress
            && this.state.validCity
            && this.state.validCountry
            && this.state.validState
            && this.state.validZipCode
            && this.state.checkPolicyAccepted
            && this.state.checkChildPolicyAccepted
        )});
    }


    /**
     * Saves the username state and verifies if the next button is ready
     * @param field
     */
    saveUsername = (field) => (newValue) =>{
        this.setState({'username': newValue.username, 'validUsername': newValue.validUsername, 'usernameAvailable': newValue.usernameAvailable},() =>{
           this.setNextButtonStatePart1();
        });
    };

    /**
     * Save the email state and verifies  if the next button is ready
     * @param field
     */
    saveEmail = (field) => (newValue) =>{
        this.setState({'email': newValue.email, 'validEmail': newValue.validEmail, 'emailAvailable': newValue.emailAvailable},() =>{
            this.setNextButtonStatePart1();
        });
    };

    /**
     * Save the password state and verifies if the next button is ready
     * @param field
     */
    savePassword = (field) => (newValue) =>{
        this.setState({'password': newValue.password, 'passwordRetype': newValue.passwordRetype, 'validPassword': newValue.validPassword},() =>{
            this.setNextButtonStatePart1();
        });
    };

    /**
     * Save the name details and verifies if the next button is ready
     * @param field
     */
    saveName = (field) => (newValue) =>{
        this.setState({'firstName': newValue.firstName, 'lastName': newValue.lastName, 'validFirstName': newValue.validFirstName, 'validLastName': newValue.validLastName},() =>{
            this.setNextButtonStatePart2();
        });
    };

    /**
     * Save the phone details and verifies if the next button is ready
     * @param filed
     */
    savePhone = (filed) => (newValue) =>{
        this.setState({'phone': newValue.phone, 'validPhone': newValue.validPhone},() =>{
            this.setNextButtonStatePart2();
        });
    };

    /**
     * Saves the address details and verifies if the next button is ready
     * @param field
     */
    saveAddress = (field) => (newValue) =>{
        this.setState(
            {
                'addressLine1': newValue.addressLine1,
                'addressLine2': newValue.addressLine2,
                'city': newValue.city,
                'country': newValue.country,
                'state': newValue.state,
                'zipCode': newValue.zipCode,
                'validAddress': newValue.validAddress,
                'validCity': newValue.validCity,
                'validCountry': newValue.validCountry,
                'validPhone': newValue.validPhone,
                'validState': newValue.validState,
                'validZipCode': newValue.validZipCode
            },() =>{
                this.setSubmitButtonState();
        });
    };

    /**
     * Renders the first part of the form
     * @returns {XML}
     */
    renderForm(){
        return (
            <div>
               <Card>
                    <CardBody>
                        <CardTitle>
                            <FontAwesomeIcon className="fa-3x" icon={faUserCircle} />{' '}
                            <Translate id="register.become-a-member"/>
                            <hr/>
                        </CardTitle>
                    </CardBody>
                    <CardBody>
                        <Form>
                            <FormGroupUsername data={this.state} updateParent={this.saveUsername()}/>
                            <FormGroupNewPassword data={this.state} updateParent={this.savePassword()}/>
                            <FormGroupEmail data={this.state} updateParent={this.saveEmail()}/>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Button color="success" block disabled={!this.state.proceedPart2} onClick={this.handleFormPart2Visibility}>
                                        <Translate id="general.next" options={{renderInnerHtml: false}}/>
                                    </Button>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Link color="link" to="/login">
                                        <Translate id="register.have-account" options={{renderInnerHtml: false}}/>
                                    </Link>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <LanguageToggle/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    };

    /**
     * Renders the second part of the form
     * @returns {XML}
     */
    renderRegisterFormPart2(){
        return (
            <div>
                <Card>
                    <CardBody>
                        <CardTitle>
                            <FontAwesomeIcon className="fa-3x" icon={faUserCircle} />{' '}
                            <Translate id="register.become-a-member" options={{renderInnerHtml: false}}/>
                        </CardTitle>
                    </CardBody>
                    <CardBody>
                        <Form>
                            <FormGroupName data={this.state} updateParent={this.saveName()}/>
                            <FormGroupPhone data={this.state} updateParent={this.savePhone()}/>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Button color="success" block disabled={!this.state.proceedPart3} onClick={this.handleFormPart3Visibility}>
                                        <Translate id="general.next" options={{renderInnerHtml: false}}/>
                                    </Button>
                                </Col>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Button color="warning" block onClick={this.backToPart1Register}>
                                        <Translate id="general.back" options={{renderInnerHtml: false}}/>
                                    </Button>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <LanguageToggle/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }

    /**
     * Renders the third part of the form
     * @returns {XML}
     */
    renderRegisterFormPart3(){
        return (
            <div>
                <Card>
                    <CardBody>
                        <CardTitle>
                            <FontAwesomeIcon className="fa-3x" icon={faUserCircle} />{' '}
                            <Translate>{({translate}) => <span>{translate("register.become-a-member")}</span>}</Translate>
                        </CardTitle>
                    </CardBody>
                    <CardBody>
                        <Form>
                            <FormGroupAddress data={this.state} updateParent={this.saveAddress()}/>
                            <FormGroup row>
                                <Col sm={{ size:10, offset: 1}}>
                                    <FormText>
                                        <Translate>{({translate}) => <span>{translate("register.subscribing-accept")}</span>}</Translate>
                                    </FormText>
                                    <FormGroup check>
                                        <Label check>
                                            <Input type="checkbox" checked={this.state.checkPolicyAccepted} name="terms" onChange={this.toggleCheckTerms} />{' '}
                                            <ModalTerms isOpen={this.state.showModalTerms} toggle={this.toggleModalTerms} color="link"/>
                                        </Label>
                                        <Label check>
                                            <Input type="checkbox" checked={this.state.checkChildPolicyAccepted} name="children" onChange={this.toggleCheckChildrenPolicy} />{' '}
                                            <ModalChildrenPolicy isOpen={this.state.showModalChildrensPolicy} toggle={this.toggleModalChildrenPolicy} />
                                        </Label>
                                    </FormGroup>
                                    <Alert color="danger" isOpen={!this.state.checkPolicyAccepted || !this.state.checkChildPolicyAccepted}>
                                        <Translate id="register.terms-error" options={{renderInnerHtml: false}}/>
                                    </Alert>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Button color="success" block disabled={!this.state.proceedSubmit} onClick={this.submitRegister}>
                                        <Translate id="general.submit" options={{renderInnerHtml: false}}/>
                                    </Button>
                                </Col>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <Button color="warning" block onClick={this.handleFormPart2Visibility}>
                                        <Translate id="general.back" options={{renderInnerHtml: false}}/>
                                    </Button>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{ size: 10, offset: 1 }}>
                                    <LanguageToggle/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody>
                </Card>

            </div>
        )
    }

    /**
     * Renders the main form element
     * @returns {XML}
     */
    render() {
        if (this.state.isLoggedIn === true)
            return (<Redirect to="/dashboard"/>);
        else {
            return (
                <Spring from={{opacity: 0}} to={{opacity: 1}} impl={TimingAnimation}
                        config={{duration: 450, easing: Easing.linear}}>
                    {
                        styles => <div>
                            <Col style={styles} xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                                <Media src={require('../img/user-icon-2.png')} alt="User icon" width="100%"/>
                            </Col>
                            <Col style={styles} sm={{size: 8, offset: 2}} md={{size:8, offset: 2}} lg={{size: 6, offset: 3}}>
                                {this.state.showFormPart1 ? this.renderForm() : null}
                            </Col>
                            <Col style={styles} sm={{size: 8, offset: 2}} lg={{size: 6, offset: 3}}>
                                {this.state.showFormPart2 ? this.renderRegisterFormPart2() : null}
                            </Col>
                            <Col style={styles} sm={{size: 8, offset: 2}} lg={{size: 6, offset: 3}}>
                                {this.state.showFormPart3 ? this.renderRegisterFormPart3() : null}
                            </Col>
                            <Col style={styles} xs={{size: 4, offset: 4}} lg={{size: 2, offset: 5}}>
                                <Link to="/">
                                <Media style={styles} src={require('../img/logo-gs-a.png')} alt="Company logo"
                                       width="100%"/>
                                </Link>
                            </Col>
                            {this.state.showErrorModal ? this.renderGenericModal() : null}
                        </div>
                    }
                </Spring>
            )
        }
    };
}

export default withLocalize(Register);


// WEBPACK FOOTER //
// ./src/components/register.js